import { render } from "./Asset_depreciation_schedule_report.vue?vue&type=template&id=c83dcb7c&scoped=true"
import script from "./Asset_depreciation_schedule_report.vue?vue&type=script&lang=js"
export * from "./Asset_depreciation_schedule_report.vue?vue&type=script&lang=js"

import "./Asset_depreciation_schedule_report.vue?vue&type=style&index=0&id=c83dcb7c&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83dcb7c"]])

export default __exports__